"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/SMSMarkOptedOutModal.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _reacthookform = require('react-hook-form');



var _usePatientsSharingSMSPhone = require('shared/hooks/usePatientsSharingSMSPhone'); var _usePatientsSharingSMSPhone2 = _interopRequireDefault(_usePatientsSharingSMSPhone);





var _smsPreference = require('shared/validation/smsPreference');







var _smsDelivery = require('shared/services/smsDelivery');

var _Modal = require('web/components/Modal'); var _Modal2 = _interopRequireDefault(_Modal);
var _Form = require('web/components/Form');











const DEFAULT_VALUES = { reason: '' }

// Any staff member who can see the patient records an opt-out the patient
// asked for by phone or in person. The reason is required and goes in the
// patient's history. If other patients share the phone, it says so: the
// opt-out stops texts to them too.
const SMSMarkOptedOutModal = ({ isOpen, orgKey, patientKey, patientName, onClose, onConfirm }) => {
  const sharingNames = _usePatientsSharingSMSPhone2.default.call(void 0, orgKey, patientKey, isOpen)
  const { control, formState, handleSubmit, reset } = _reacthookform.useForm({
    mode: 'onChange',
    resolver: _smsPreference.smsPreferenceReasonResolver,
    defaultValues: DEFAULT_VALUES,
  })
  const { isValid, isSubmitting, errors } = formState

  _react.useEffect.call(void 0, () => { if (isOpen) reset(DEFAULT_VALUES) }, [isOpen, reset])

  const submit = _react.useCallback.call(void 0, 
    ({ reason }) => onConfirm(reason.trim()),
    [onConfirm],
  )

  return (
    _react2.default.createElement(_Modal2.default, {
      isOpen: isOpen,
      onClose: onClose,
      title: _smsDelivery.SMS_MARK_OPTED_OUT_TITLE,
      className: "sms-mark-opted-out-modal",
      size: "xs", __self: this, __source: {fileName: _jsxFileName, lineNumber: 58}}

      , _react2.default.createElement(_Modal.ModalSubtitle, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 65}}, "Mark "
         ,  patientName || 'this patient' , " opted out of texts?"
      )
      , _react2.default.createElement(_Modal.ModalDesc, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 68}},  _smsDelivery.SMS_MARK_OPTED_OUT_COPY )
      ,  !!sharingNames.length && (
        _react2.default.createElement(_Modal.ModalDesc, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 70}},  _smsDelivery.makeSMSSharedPhoneWarning.call(void 0, sharingNames) )
      )
      , _react2.default.createElement(_Form.InputSectionWrapper, {
        title: _smsDelivery.SMS_PREFERENCE_REASON_LABEL,
        errorMessage: _optionalChain([errors, 'access', _ => _.reason, 'optionalAccess', _2 => _2.message]),
        className: "sms-preference-reason", __self: this, __source: {fileName: _jsxFileName, lineNumber: 72}}

        , _react2.default.createElement(_Form.SimpleTextAreaController, {
          autoFocus: true,
          name: "reason",
          control: control,
          'aria-label': _smsDelivery.SMS_PREFERENCE_REASON_LABEL,
          placeholder: _smsDelivery.SMS_MARK_OPTED_OUT_REASON_PLACEHOLDER,
          maxLength: _smsPreference.SMS_PREFERENCE_REASON_MAX_LENGTH, __self: this, __source: {fileName: _jsxFileName, lineNumber: 77}}
        )
      )
      , _react2.default.createElement(_Modal.ModalControls, {
        primaryBtnLabel: _smsDelivery.SMS_MARK_OPTED_OUT_CONFIRM_LABEL,
        primaryBtnTheme: "danger",
        secondaryBtnLabel: "Cancel",
        isPrimaryLoading: isSubmitting,
        isPrimaryEnabled: isValid && !isSubmitting,
        onPrimaryBtnClick: handleSubmit(submit),
        onSecondaryBtnClick: onClose, __self: this, __source: {fileName: _jsxFileName, lineNumber: 86}}
      )
    )
  )
}

exports. default = SMSMarkOptedOutModal
